import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import Styles from './Input.module.scss';

const TextArea = ({
  label,
  required,
  value,
  onChange,
  rows,
  cols,
  placeholder,
  name,
  errors,
  touched,
  disabled,
  style,
  containerStyle,
}) => {
  const [initialValue, setInitialValue] = useState(value);

  const handleChange = (event) => {
    const newValue = DOMPurify.sanitize(event.target.value);
    setInitialValue(newValue);
    if (onChange) {
      onChange(name, newValue);
    }
  };

  useEffect(() => {
    setInitialValue(value);
  }, [value]);

  return (
    <div
      className={`${
        errors && touched
          ? Styles['textBox-container-error']
          : Styles['textBox-container']
      }`}
      style={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        ...containerStyle,
      }}
    >
      <label htmlFor={label}>
        {label}
        {required && <span className={Styles.required}>*</span>}
      </label>
      <textarea
        id={label}
        required={required}
        onChange={handleChange}
        value={initialValue}
        rows={rows}
        cols={cols}
        placeholder={placeholder}
        disabled={disabled}
        style={{ ...style }}
      />
    </div>
  );
};

export default TextArea;
